export var nextTick = function () {
  var isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
  if (isPromiseAvailable) {
    return function (cb) {
      return Promise.resolve().then(cb);
    };
  } else {
    return function (cb, setTimeoutFn) {
      return setTimeoutFn(cb, 0);
    };
  }
}();
export var globalThisShim = function () {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();
export var defaultBinaryType = "arraybuffer";
export function createCookieJar() {}